(function ($, Cobalt, undefined) {
    Cobalt.ForumFilters = {
        getCookieName: function(userID) {
            return "userForumFilters_" + (userID || 0);
        },
        initialize: function() {

            var $forumFiltersForm = $("#forum-filters-form");

            if ($forumFiltersForm.length > 0) {
                // set any settings if they have them
                var cookie = $.cookie(Cobalt.ForumFilters.getCookieName(Cobalt.User.ID));
                if (cookie) {
                    var $forums = $forumFiltersForm.find("input.j-forum-filters");
                    
                    var values = cookie.split(',');
                    $forums.filter(function () {
                        return $.inArray($(this).val(), values) >= 0;
                    })
                    .prop("checked", true);
                } else {
                    $forumFiltersForm.find("input.j-forum-filters").prop("checked", true);
                }

                // reset button
                $forumFiltersForm.on("click", ".j-reset", function(e) {
                    e.preventDefault();

                    $forumFiltersForm.find("input.j-forum-filters").prop("checked", true); // re-check all options
                    
                    var selectedOptions = $forumFiltersForm.find("input.j-forum-filters:checked").map(function () {
                        return $(this).val();
                    }).toArray().join();
                    Cobalt.ForumFilters.updatePageBlock(selectedOptions);

                    $.cookie(Cobalt.ForumFilters.getCookieName(Cobalt.User.ID), null); //kill cookie
                    $(".ui-dialog-titlebar-close").click(); //close

                });

                // accept button
                $forumFiltersForm.on("click", ".j-accept", function(e) {
                    e.preventDefault();

                    var selectedOptions = $forumFiltersForm.find("input.j-forum-filters:checked").map(function() {
                        return $(this).val();
                    }).toArray().join();

                    if (!selectedOptions) {
                        $forumFiltersForm.find(".errors").text("At least one Forum must be selected.").css("color", "red");
                        return;
                    } else {
                        $forumFiltersForm.find(".errors").text("");
                    }

                    Cobalt.ForumFilters.updatePageBlock(selectedOptions);

                    $.cookie(Cobalt.ForumFilters.getCookieName(Cobalt.User.ID), selectedOptions);
                    $(".ui-dialog-titlebar-close").click(); //close
                });
            }
        },
        updatePageBlock: function(forums) {
            if (forums) {
                var $forumTopicsBlocks = $(".forum-topics-page-block[data-allow-user-filtering='true']"); //only find blocks with user filtering
                $forumTopicsBlocks.each(function () {
                    var $that = $(this);
                    var itemsToDisplay = $that.data("items-to-display");
                    var orderByComments = $that.data("order-by-comment") === true ? 1 : 0;                    
                    $.get(Cobalt.Routes.Instance.ForumGetForumLatestThreads({ forumIDs: forums, itemsToDisplay: itemsToDisplay, orderByComments: orderByComments }), function (data) {                        
                        if (data) {
                            if (data.status === "success" && data.threadHtml) {
                                $that.empty().append(data.threadHtml);
                            }
                        }                        
                    });
                });
            }
        }
    };
})(jQuery, Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.ForumFilters.js